export const StatiPratica = {
    inLavorazione: 'In Lavorazione',
    checkOutOperatore: 'Check Out Operatore',
    chiusa: 'Chiusa',
    daApprovare: 'Da Approvare',
    inRichiesta: 'In Richiesta',
    inAttesaOpzionali: 'In Attesa Opzionali',
    infoComplete: 'Info Complete',
    annullata: 'Annullata'
}